import { app } from '../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {

    $stateProvider.state('public.hard-token-sync', {
        url: '/htsync',
        component: 'hardTokenSync',
    });

    $stateProvider.state('public.hard-token-sync-with-tracker', {
        url: '/htsync/:tracker',
        component: 'hardTokenSync',
    });
}



// WEBPACK FOOTER //
// ./src/portal/states/public/hard-token-sync/hard-token-sync.state.js